
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/private-app-chatbot-mcp",
      function () {
        return require("private-next-pages/docs/private-app-chatbot-mcp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/private-app-chatbot-mcp"])
      });
    }
  